import { startListening, appSync } from '@bonanza-social/toolkit/state';
import { fetchSpinsCount } from './instantWheel.slice';

startListening({
  actionCreator: appSync,
  effect: (_, { dispatch }) => {
    dispatch(fetchSpinsCount());
  },
});
